import PropertyTabs from './PropertyTabs';

export default PropertyTabs;
